import * as swcHelpers from '@swc/helpers';
import { LocaleUtils } from '@grandvisionhq/utils';
import { getToken } from './token-service.js';

const getCustomerUri = (apiUrl, customerId)=>`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}`
;
const getAccountUri = (apiUrl)=>`${apiUrl}/customers/account`
;
const unwrapResponse = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(response) {
        if (!response.ok) {
            let result = '';
            try {
                result = yield response.text();
            } catch (e) {}
            throw new Error(`Got non OK response from server: ${response.status} ${response.statusText}: ${result}`);
        }
        return response.json();
    });
    return function unwrapResponse(response) {
        return _ref.apply(this, arguments);
    };
}();
const baseOptions = {
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-cache'
};
/**
 * @deprecated use the new GQL hook
 * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
 */ const optIns = {
    /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */ fetch (apiUrl, customerId) {
        return swcHelpers.asyncToGenerator(function*() {
            const accessToken = yield getToken();
            return unwrapResponse((yield fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'GET',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                })
            }))));
        })();
    },
    /**
   * @deprecated use the new GQL hook
   * packages/auth/src/OptIns/hooks/use-available-opt-ins.ts
   */ update (apiUrl, customerId, optinUpdates) {
        return swcHelpers.asyncToGenerator(function*() {
            const accessToken = yield getToken();
            return unwrapResponse((yield fetch(`${getCustomerUri(apiUrl, customerId)}/optins`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    optinUpdates
                })
            }))));
        })();
    }
};
const account = {
    signup (apiUrl, loginRedirectUrl, emailAddress, additionalAccountData, reason) {
        return swcHelpers.asyncToGenerator(function*() {
            const { personalDetails ={} , optins ={}  } = additionalAccountData;
            const optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
            const additionalData = {
                personalDetails,
                optins: optInsUpdate
            };
            const locale = LocaleUtils.getLocaleFromCookie();
            const stateParams = {
                targetAction: 'signUp'
            };
            let body = swcHelpers.objectSpread({
                loginRedirectUrl,
                emailAddress,
                state: JSON.stringify(stateParams),
                reason
            }, additionalData);
            body = locale ? swcHelpers.objectSpread({}, body, {
                locale
            }) : body;
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/create`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(body)
            }))));
        })();
    },
    activate (apiUrl, accessToken, accountId, emailAddress, password, consents1) {
        return swcHelpers.asyncToGenerator(function*() {
            const locale = LocaleUtils.getLocaleFromCookie();
            let body = {
                emailAddress,
                password,
                consents: consents1
            };
            body = locale ? swcHelpers.objectSpread({}, body, {
                locale
            }) : body;
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/activate/${encodeURIComponent(accountId)}`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(body)
            }))));
        })();
    },
    changePassword (apiUrl, accessToken, accountId, password) {
        return swcHelpers.asyncToGenerator(function*() {
            return unwrapResponse((yield fetch(`${getAccountUri(apiUrl)}/changepassword/${encodeURIComponent(accountId)}`, swcHelpers.objectSpread({}, baseOptions, {
                method: 'POST',
                headers: new Headers({
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    password
                })
            }))));
        })();
    }
};

export { account, optIns };
//# sourceMappingURL=customer-service.js.map
